var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineGpsSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.7 19.56a.76.76 0 0 1-.39-.99.76.76 0 0 1 .99-.39c.85.37 1.76.56 2.7.56 3.72 0 6.75-3.03 6.75-6.75 0-.94-.19-1.85-.56-2.7a.751.751 0 1 1 1.38-.6c.46 1.04.69 2.15.69 3.3-.01 4.56-3.71 8.26-8.26 8.26-1.15 0-2.26-.23-3.3-.69zM6.04 17.71A8.217 8.217 0 0 1 3.75 12c0-4.55 3.7-8.25 8.25-8.25 2.15 0 4.18.82 5.73 2.31.3.29.31.76.02 1.06-.29.3-.76.31-1.06.02A6.729 6.729 0 0 0 12 5.25c-3.72 0-6.75 3.03-6.75 6.75 0 1.75.67 3.41 1.88 4.67.29.3.28.77-.02 1.06a.758.758 0 0 1-1.07-.02z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 4V2c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM2 12.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2c.41 0 .75.34.75.75s-.34.75-.75.75H2zM11.25 22v-2c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM20 12.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2c.41 0 .75.34.75.75s-.34.75-.75.75h-2z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.35 14.65c-.71-.71-1.1-1.65-1.1-2.65 0-2.07 1.68-3.75 3.75-3.75 1 0 1.94.39 2.65 1.1.29.29.29.77 0 1.06l-4.24 4.24c-.15.15-.34.22-.53.22s-.38-.07-.53-.22zm.4-2.65c0 .34.08.67.22.97l3-3c-.3-.14-.63-.22-.97-.22-1.24 0-2.25 1.01-2.25 2.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.47 22.53a.754.754 0 0 1 0-1.06l20-20c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-20 20c-.15.15-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineGpsSlash);
export default __webpack_public_path__ + "static/media/vuesax-outline-gps-slash.917623ac7574784b26156dc2a5e7ff40.svg";
export { ForwardRef as ReactComponent };